<template>
  <div class="project-all">
    <commonTable :height="'100%'" :config="{nothing:nothing}" @button-click="$emit('button-click')" tableHead="projectall" :dataset="dataset" ref="commonTable" :verifyRemark="true" :isSelfMak="true" :selection="false" :tipShow="false" v-loading="loading" :rowStyle="{cursor: 'pointer'}" @selectSingle="rowClick">
      <template slot="title" slot-scope="dataset">
        <span @click="toProject(dataset.data.project_id)">{{dataset.data.title}}</span>
      </template>
      <template slot="addtime" slot-scope="dataset">
        <span>{{dataset.data.addtime | formatDate}}</span>
      </template>
      <template slot="creator" slot-scope="dataset">
        <span>{{ dataset.data.creator ? dataset.data.creator.realname : '-' }}</span>
      </template>
      <template slot="archived_time" slot-scope="dataset">
        <span>{{dataset.data.archived_time | formatDate}}</span>
      </template>
      <template slot="isJoin" slot-scope="dataset">
        <span>{{ dataset.data.isJoin ? '已加入' : '未加入'}}</span>
      </template>
      <template slot="verifyRemark" slot-scope="dataset">
        <span @click="actProject(dataset.data)">
          <i class="icon iconfont iconicon_restore" style="font-size: 14px;margin-right: 8px;"></i>
          激活此项目
        </span>
      </template>
      <template slot="delete_time" slot-scope="dataset">
        <span>{{dataset.data.delete_time | formatDate}}</span>
      </template>
    </commonTable>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex';
import api from '@/services/api/project/project'
export default {
  name: "projectAll",
  props: {
    defStatus: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      actionType: {
        active: {
          params: '',
          head: 'projectall',
          name: '活跃中'
        },
        archived: {
          params: 'active_project',
          head: 'projectallAr',
          name: '归档'
        },
        sleep: {
          params: 'open_project',
          head: 'projectall',
          name: '冻结'
        },
        delete: {
          params: 'resume_project',
          head: 'projectallDel',
          name: '删除'
        }
      },
      departMap: [],
      // defStatus: "active",
      defDepart: "",
      projectGroupList: {},
      dataset: [],
      loading: false,
      timer: null,
      nothing: {
        tip: '',
        btnText: '',
        type: 'img_no_archive_task'
      }
    }
  },
  computed: {
    ...mapState('home/home', {
      keyword: state => state.keyword
    })
  },
  watch: {
    defStatus() {
      this.$refs.commonTable && this.$refs.commonTable.init(this.actionType[this.defStatus].head)
      this.nothing.tip = `暂无${this.actionType[this.defStatus].name}项目～`
      this.fetchProjectByStatus();
    },
    keyword() {
      this.debounce(this.fetchProjectByStatus, 300)
    }
  },
  mounted() {
    this.nothing.tip = `暂无${this.actionType[this.defStatus].name}项目～`
    this.$refs.commonTable && this.$refs.commonTable.init(this.actionType[this.defStatus].head)
    this.fetchProjectByStatus();
  },
  created() {
    this.$permission('项目管理-新增项目') && this.defStatus === 'active' ? this.nothing.btnText = '新建项目' : this.nothing.btnText = ''
  },
  methods: {
    ...mapActions("project/project", ["activateProject"]),
    //防抖函数
    debounce(fn, wait) {
      if (this.timer !== null) {
        clearTimeout(this.timer)
      }
      this.timer = setTimeout(fn, wait)
    },
    async fetchProjectByStatus() {
      this.loading = true
      let result = await api.departmentProjectByV2({
        department_category_id: this.$route.query.project_depart_id,
        project_list_id: this.$route.query.project_list_id,
        project_status: this.defStatus,
        keyword: this.keyword
      })
      result.joined.map(res => res.isJoin = true)
      result.not_joined.map(res => res.isJoin = false)
      this.$refs.commonTable.selfPageSplit([...result.joined, ...result.not_joined])
      this.loading = false
    },
    changeStatus(itemData) {
      this.defDepart = "";
      this.fetchProjectByStatus();
    },
    changeDepart(itemData) {
      this.fetchProjectByStatus();
    },
    groupProjectByDepartment(sourceData) {
      let temp = {};
      sourceData.forEach((item) => {
        if (temp[item.project_depart_name]) {
          temp[item.project_depart_name].push(item);
        } else {
          temp[item.project_depart_name] = [item];
        }
      })
      return temp;
    },
    async actProject(itemData) {
      await this.$wfAlert('warning', '提示', `你确定要激活【${itemData.title}】项目?`, '确定')
      await this.activateProject({
        project_id: itemData.project_id,
        action: this.actionType[this.defStatus].params
      })
      this.$emit('fetchProjectList')
      this.fetchProjectByStatus();
    },
    toProject(project_id) {
      this.$router.push('/task?isTabShow=true&projectId=' + project_id)
    },
    rowClick(data) {
      console.log(data)
      this.$router.push(`/task?projectId=${data.project_id}&isTabShow=true`)
    }
  }
}
</script>

<style lang="scss" scoped>
.project-all {
  // width: 100%;
  // height: 100%;
  // background: #f8f9fb;
  // border: 1px solid #e7e8ed;
  // border-radius: 8px;
  // display: flex;
  // overflow: hidden;
  height: 0;
  flex: 1;
  .project-type,
  .project-depart {
    width: 145px;
    border-right: 1px solid #e7e8ed;
    height: 100%;
    padding: 10px;
    font-size: 14px;
  }
  .project-list {
    flex: 1;
    overflow: auto;
  }
  .type-item,
  .depart-item {
    cursor: pointer;
    text-align: center;
    width: 100%;
    height: 32px;
    line-height: 32px;
    border-radius: 4px;
    margin-bottom: 10px;
  }
  .type-item:hover {
    background: #dde9fb;
  }
  .type-item.active {
    background: #509aff;
    color: #fff;
  }
  .depart-item.active,
  .depart-item:hover,
  .active-pro:hover {
    color: #509aff;
  }
  .active-pro {
    cursor: pointer;
  }
  /deep/ {
    .common-table{
      display: flex;
      flex-direction: column;
    }
    .multipleTable-box {
      height: 0;
      flex: 1;
      padding: 0 40px;
    }
  }
}
</style>
